export default {"src":"/_next/static/media/house-and-bushes.bd408fa8.svg","height":66,"width":145,"blurWidth":0,"blurHeight":0};